import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, money } from "../lib/api";
import { LogOut, Package, User as UserIcon } from "lucide-react";

export default function Account() {
  const { user, logout } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (user === false) navigate("/login", { state: { from: "/account" } });
  }, [user, navigate]);

  useEffect(() => {
    if (user && user.user_id) {
      api.get("/orders").then((r) => setOrders(r.data)).catch(() => {}).finally(() => setLoading(false));
    }
  }, [user]);

  if (!user) return <div className="pt-40 pb-40 text-center text-zinc-500">Loading...</div>;

  return (
    <div className="pt-28 pb-24">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between flex-wrap gap-4 mb-12">
          <div className="flex items-center gap-4">
            {user.picture
              ? <img src={user.picture} alt="" className="h-14 w-14 rounded-full object-cover border border-[#27272a]" />
              : <div className="h-14 w-14 bttf-gradient flex items-center justify-center text-black"><UserIcon size={26} /></div>}
            <div>
              <h1 className="font-display text-4xl uppercase leading-none">{user.name || "My Account"}</h1>
              <p className="text-zinc-400 text-sm">{user.email}{user.role === "admin" ? " · Admin" : ""}</p>
            </div>
          </div>
          <button onClick={logout} data-testid="logout-btn" className="flex items-center gap-2 border border-[#27272a] hover:border-[#00f0ff] px-5 py-2.5 text-sm uppercase tracking-wider transition-colors">
            <LogOut size={16} /> Log Out
          </button>
        </div>

        <div className="flex items-center gap-3 mb-6">
          <Package className="text-[#00f0ff]" size={20} />
          <h2 className="font-display text-2xl uppercase">Order History</h2>
        </div>

        {loading ? (
          <div className="text-zinc-500">Loading orders...</div>
        ) : orders.length === 0 ? (
          <div className="border border-[#27272a] p-10 text-center text-zinc-400">No orders yet.</div>
        ) : (
          <div className="space-y-4" data-testid="order-history">
            {orders.map((o) => (
              <div key={o.id} className="border border-[#27272a] p-5" data-testid={`order-${o.order_number}`}>
                <div className="flex items-center justify-between flex-wrap gap-2">
                  <div>
                    <div className="font-mono text-[#00f0ff]">{o.order_number}</div>
                    <div className="text-xs text-zinc-500">{new Date(o.created_at).toLocaleString()}</div>
                  </div>
                  <div className="text-right">
                    <div className="font-bold">{money(o.total)}</div>
                    <div className="text-xs uppercase tracking-wider text-zinc-400">{o.status}</div>
                  </div>
                </div>
                <div className="mt-3 pt-3 border-t border-[#1c1c1c] flex flex-wrap gap-2 text-sm text-zinc-400">
                  {o.items?.map((it, i) => <span key={i}>{it.quantity}× {it.name}{i < o.items.length - 1 ? " ·" : ""}</span>)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
